import { render } from "./ToggleButtons.vue?vue&type=template&id=806b47c6"
import script from "./ToggleButtons.vue?vue&type=script&lang=js"
export * from "./ToggleButtons.vue?vue&type=script&lang=js"

import "./ToggleButtons.vue?vue&type=style&index=0&id=806b47c6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__